import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c5lwttyyt1: FaireBrandEntity = {
  token: "b_c5lwttyyt1",
  type: "brand",
  name: "Tomoko Maruyama",
  avatarUrl:
    "https://cdn.faire.com/fastly/93458a4b0d10daf66220108b2bf864d04e7e9ceb022d0a868ae5ad1d329b12e6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1aae634fba15b93fb943aeb2ffa9d90919b8058e31b2c32f0c8b385c89db7b3e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/93458a4b0d10daf66220108b2bf864d04e7e9ceb022d0a868ae5ad1d329b12e6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1aae634fba15b93fb943aeb2ffa9d90919b8058e31b2c32f0c8b385c89db7b3e.jpeg",
  location: "WA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    'Tomoko Maruyama was born in Japan and raised in Asakusa, a historic district of Tokyo. Growing up in her grandparents’ art and gift store near Sensō-ji, Tokyo’s oldest Buddhist temple, she was immersed in a world of creativity and culture. Interacting with visitors from around the world, she developed a deep appreciation for art, storytelling, and the significance of meaningful gifts.\n\nEager to explore beyond Japan, Tomoko moved to the U.S. to pursue her passion for art. After graduating, she worked as a graphic designer at an advertising firm in New York City, refining her skills in visual communication and branding.\n\nDrawn to the creative energy of San Francisco, she later established her own design studio in the SoMa district. Inspired by the city\'s charm, she launched "Colors of San Francisco," a brand celebrating its beauty through art prints, stationery, and gifts. Her work is now featured in select museums and specialty stores across California.\n\nIn 2020, Tomoko expanded her artistic journey with a second studio in Seattle, Washington. The natural beauty and cultural richness of the Puget Sound region provide plenty of artistic inspiration.',
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:21.199Z",
    importedBy: "entity-db-cli",
  },
};
